import React, { useState } from 'react';
import { useNotify, useTranslate, useUpdate } from 'react-admin';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from '@material-ui/core';
import { Order } from '../../types';

type Props = {
    record: Order;
    disabled?: boolean;
};

const UpdateActualSizeButton: React.FC<Props> = ({ record, disabled }) => {
    const notify = useNotify();
    const translate = useTranslate();
    const [isOpen, setIsOpen] = useState(false);
    const [actualSize, setActualSize] = useState(record.actualSize);

    const [cancelOrder, { loading }] = useUpdate(
        'orders',
        record.id,
        { actualSize: parseFloat(actualSize) },
        record,
        {
            undoable: false,
            onSuccess: () => {
                notify('resources.orders.notification.update_success', 'info');
            },
            onFailure: () => {
                notify('resources.orders.notification.update_error', 'warning');
            },
        }
    );

    const handleActualSizeChange = event => {
        setActualSize(event.target.value.trim());
    };

    return (
        <span className="mx-2">
            <Button
                variant="outlined"
                color="secondary"
                size="small"
                disabled={disabled || loading}
                onClick={() => setIsOpen(true)}
            >
                Update Actual Size
            </Button>

            <Dialog
                fullWidth={true}
                maxWidth="sm"
                open={isOpen}
                onClose={() => setIsOpen(false)}
            >
                <DialogTitle>Update Actual Size</DialogTitle>

                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="actualSize"
                        label="Actual Size"
                        type="number"
                        variant="outlined"
                        value={actualSize}
                        required
                        onChange={handleActualSizeChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setIsOpen(false)}>
                        {translate('action.close')}
                    </Button>

                    <Button
                        variant="contained"
                        color="secondary"
                        disabled={
                            disabled ||
                            loading ||
                            !Number.isFinite(parseFloat(actualSize))
                        }
                        onClick={() => {
                            cancelOrder();
                            setIsOpen(false);
                        }}
                    >
                        {translate('action.update')}
                    </Button>
                </DialogActions>
            </Dialog>
        </span>
    );
};

export default UpdateActualSizeButton;
